// apiUtils.js

import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL } from "../settings/appConfig.js.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.js";
import { logout } from "../store/authentication/authSlice.js";

const commonHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const ApiUtils = () => {
  const token = useSelector((state) => state.auth.userToken);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleResponse = async (response) => {
    if (!response.ok) {
      console.log("Response", response.error);
      if (response.status === 401) {
        await dispatch(logout());
        history.push("/auth/sign-in");
        return;
      }
      let errorMessage;
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || "Unknown error occurred";
      } catch (jsonError) {
        errorMessage = "An error occurred while processing the request.";
      }
      throw new Error(errorMessage);
    }
    return response.json();
  };

  const request = async (endpoint, method, requestData) => {
    const url = `${API_BASE_URL}/${endpoint}`;
    await checkNetworkStatus();
    await checkAPIEndPoint(endpoint);
    try {
      const headers = {
        ...commonHeaders,
        Authorization: `Bearer ${token}`,
      };

      const options = {
        method,
        headers,
      };

      if (requestData) {
        options.body = JSON.stringify(requestData);
      }

      const response = await fetch(url, options);
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  };

  const fetchData = async (endpoint) => {
    try {
      return request(endpoint, "GET");
    } catch (error) {
      throw error;
    }
  };

  const postData = async (endpoint, requestData) => {
    try {
      return request(endpoint, "POST", requestData);
    } catch (error) {
      throw error;
    }
  };

  const putData = async (endpoint, requestData) => {
    try {
      return request(endpoint, "PUT", requestData);
    } catch (error) {
      throw error;
    }
  };

  const deleteData = async (endpoint) => {
    try {
      return request(endpoint, "DELETE");
    } catch (error) {
      throw error;
    }
  };

  const checkNetworkStatus = async () => {
    if (!navigator.onLine) {
      throw new Error(
        "No internet connection. Please check your network settings."
      );
    }
  };

  const checkAPIEndPoint = async (endpoint) => {
    const url = `${API_BASE_URL}/employee/user/getall`;
    try {
      await fetch(url, { method: "GET" });
    } catch (error) {
      throw new Error(
        "Internal network error. Please contact the system administrator."
      );
    }
  };

  return { fetchData, postData, putData, deleteData };
};

export default ApiUtils;
